/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export const addressLayoutData = {
  de: {
    usage: {
      element: {
        control: 'flex',
      },
    },
    sharedGroupPostalCode: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    sharedGroupStreet: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    postalCode: {
      grid: {
        host: 'w-full s:w-1/4 mt-static_s',
      },
    },
    city: {
      grid: {
        host: 'ms-0 s:ms-static_m flex-grow mt-static_s',
      },
    },
    companyName1: {
      element: {
        container: 'mt-static_m',
      },
    },
    coName: {
      element: {
        container: 'mt-static_m',
      },
    },
    vatId: {
      element: {
        container: 'mt-static_m',
      },
    },
    street1: {
      grid: {
        host: 'flex-grow',
      },
    },
    houseNumber: {
      grid: {
        host: 'ms-0 s:ms-static_m w-full s:w-1/4',
      },
    },
    country: {
      element: {
        container: 'mt-static_m',
      },
    },
    isStandard: {
      element: {
        container: 'mt-static_m',
      },
    },
  },
  cy: {
    usage: {
      element: {
        control: 'flex',
      },
    },
    sharedGroupPostalCode: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    sharedGroupStreet: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    postalCode: {
      grid: {
        host: 'w-full s:w-1/4',
      },
    },
    city: {
      grid: {
        host: 'ms-0 s:ms-static_m flex-grow',
      },
    },
    companyName1: {
      element: {
        container: 'mt-static_m',
      },
    },
    coName: {
      element: {
        container: 'mt-static_m',
      },
    },
    vatId: {
      element: {
        container: 'mt-static_m',
      },
    },
    street1: {
      grid: {
        host: 'flex-grow',
      },
    },
    houseNumber: {
      grid: {
        host: 'ms-0 s:ms-static_m w-full s:w-1/4',
      },
    },
    country: {
      element: {
        container: 'mt-static_m',
      },
    },
    isStandard: {
      element: {
        container: 'mt-static_m',
      },
    },
  },
  fr: {
    usage: {
      element: {
        control: 'flex',
      },
    },
    sharedGroupPostalCode: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    sharedGroupStreet: {
      element: {
        control: 'flex flex-col m:flex-row',
      },
    },
    postalCode: {
      grid: {
        host: 'w-full s:w-1/4',
      },
    },
    city: {
      grid: {
        host: 'ms-0 s:ms-static_m flex-grow',
      },
    },
    companyName1: {
      element: {
        container: 'mt-static_m',
      },
    },
    coName: {
      element: {
        container: 'mt-static_m',
      },
    },
    supplement: {
      element: {
        container: 'mt-static_m',
      },
    },
    vatId: {
      element: {
        container: 'mt-static_m',
      },
    },
    street1: {
      grid: {
        host: 'flex-grow',
      },
    },
    houseNumber: {
      grid: {
        host: 'ms-0 s:ms-static_m w-full s:w-1/4',
      },
    },
    country: {
      element: {
        container: 'mt-static_m',
      },
    },
    isStandard: {
      element: {
        container: 'mt-static_m',
      },
    },
  },
}
